import React, {
    useEffect
} from 'react';
import * as UTILS from "../utils";

import LoadingIndicator from '../components/loading-indicator';

export default function DeliveryOptions(props) {

    const deliveryType = props.basketData && props.basketData.ticketDelivery ? props.basketData.ticketDelivery.type : "PrintAtHome"
    const deliveryAddress = UTILS.getDeliveryAddress(props.basketData);

    useEffect(() => {
        if (!props.basketData?.ticketDelivery) {
            props.setPatchBody({ TicketDelivery : { Type : "PrintAtHome", Address : deliveryAddress }});
        }
    }, [props.basketData])

    return (
        <section className='booking-pathway__delivery-options'>
            <h2 className='booking-pathway__header'>Delivery</h2>
            {!props.basketData || !props.basketData.ticketDeliveryOptions ?
                <LoadingIndicator />
            :
                <form>
                    {props.basketData.ticketDeliveryOptions.map((option) => (
                        <div key={option.type} className='form-field--radio'>
                            <input type='radio' 
                                    name="delivery-option"
                                    value={option.type} 
                                    id={`delivery-option_${option.type}`}
                                    onClick={() => props.setPatchBody({ TicketDelivery : { Type : option.type, Address : deliveryAddress }})}
                                    defaultChecked={option.type == deliveryType} />
                            <label htmlFor={`delivery-option_${option.type}`}>
                                {option.type == 'PrintAtHome' ? 
                                    `E-ticket (Free)`
                                : option.type == 'Postal' ?
                                    `By post (£${option.fee.toFixed(2)})`
                                : 
                                `${option.type} (${option.fee.toFixed(2)})`
                                }
                            </label>
                        </div>
                    ))}
                </form>
            }
        </section>
    );
}